﻿[
    {
        "Id": "Deceased",
        "CaptionEnglish": "Deceased",
        "CaptionFrench": "Décédé",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst204",
        "TaxpayerPrevYearCell": "FileStat.Towfst183",
        "BackgrounColor": "#353535",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 1
    },
    {
        "Id": "Retired",
        "CaptionEnglish": "Retirement",
        "CaptionFrench": "Retraite",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst205",
        "TaxpayerPrevYearCell": "FileStat.Towfst184",
        "BackgrounColor": "#DADADA",
        "ForegroundColor": "#000000",
        "YearToCheck": 4
    },
    {
        "Id": "Tuition",
        "CaptionEnglish": "Tuition",
        "CaptionFrench": "Scolarité",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst206",
        "TaxpayerPrevYearCell": "FileStat.Towfst185",
        "BackgrounColor": "#EA8F00",
        "ForegroundColor": "#000000",
        "YearToCheck": 4
    },
    {
        "Id": "Business_Income",
        "CaptionEnglish": "Business",
        "CaptionFrench": "Entreprise",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst207",
        "TaxpayerPrevYearCell": "FileStat.Towfst186",
        "BackgrounColor": "#425E10",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "Employment_expenses",
        "CaptionEnglish": "Employ. expenses",
        "CaptionFrench": "Dépenses d'emploi",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst208",
        "TaxpayerPrevYearCell": "FileStat.Towfst187",
        "BackgrounColor": "#008162",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "Rental_income",
        "CaptionEnglish": "Rental",
        "CaptionFrench": "Location",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst209",
        "TaxpayerPrevYearCell": "FileStat.Towfst188",
        "BackgrounColor": "#648D18",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "Multiple_Jurisdictions",
        "CaptionEnglish": "T2203 (MJ)",
        "CaptionFrench": "T2203 (MJ)",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst210",
        "TaxpayerPrevYearCell": "FileStat.Towfst189",
        "BackgrounColor": "#A6D1EA",
        "ForegroundColor": "#000000",
        "YearToCheck": 4
    },
    {
        "Id": "Dependents",
        "CaptionEnglish": "Dependants",
        "CaptionFrench": "PAC",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst211",
        "TaxpayerPrevYearCell": "FileStat.Towfst190",
        "BackgrounColor": "#F8D8A6",
        "ForegroundColor": "#000000",
        "YearToCheck": 4
    },
    {
        "Id": "Foreign_income",
        "CaptionEnglish": "Foreign",
        "CaptionFrench": "Étranger",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst212",
        "TaxpayerPrevYearCell": "FileStat.Towfst191",
        "BackgrounColor": "#AF6B00",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "Bankruptcy",
        "CaptionEnglish": "Bankruptcy",
        "CaptionFrench": "Faillite",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst214",
        "TaxpayerPrevYearCell": "FileStat.Towfst193",
        "BackgrounColor": "#E6F2F9",
        "ForegroundColor": "#000000",
        "YearToCheck": 1
    },
    {
        "Id": "Quebec",
        "CaptionEnglish": "Quebec",
        "CaptionFrench": "Québec",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst215",
        "TaxpayerPrevYearCell": "FileStat.Towfst194",
        "BackgrounColor": "#007AC3",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "T1-ADJ",
        "CaptionEnglish": "T1-ADJ",
        "CaptionFrench": "T1-ADJ",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst216",
        "TaxpayerPrevYearCell": "FileStat.Towfst195",
        "BackgrounColor": "#AF4995",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "T5013_Partnership",
        "CaptionEnglish": "T5013",
        "CaptionFrench": "T5013",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst217",
        "TaxpayerPrevYearCell": "FileStat.Towfst196",
        "BackgrounColor": "#00C9A5",
        "ForegroundColor": "#000000",
        "YearToCheck": 4
    },
    {
        "Id": "Alternative_Minimum_Tax",
        "CaptionEnglish": "T691",
        "CaptionFrench": "T691",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst218",
        "TaxpayerPrevYearCell": "FileStat.Towfst197",
        "BackgrounColor": "#721017",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "Investment_income",
        "CaptionEnglish": "Investments",
        "CaptionFrench": "Investissements",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst219",
        "TaxpayerPrevYearCell": "FileStat.Towfst198",
        "BackgrounColor": "#710C94",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "Net_capital_gain_loss",
        "CaptionEnglish": "Capital gains",
        "CaptionFrench": "Gains capital",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst213",
        "TaxpayerPrevYearCell": "FileStat.Towfst192",
        "BackgrounColor": "#F29097",
        "ForegroundColor": "#000000",
        "YearToCheck": 4
    },
    {
        "Id": "ACB",
        "CaptionEnglish": "ACB",
        "CaptionFrench": "PBR",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst220",
        "TaxpayerPrevYearCell": "FileStat.Towfst199",
        "BackgrounColor": "#AC1822",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "Tax_Shelter",
        "CaptionEnglish": "Tax shelters",
        "CaptionFrench": "Abris fiscaux",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst221",
        "TaxpayerPrevYearCell": "FileStat.Towfst200",
        "BackgrounColor": "#22086B",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "T1135",
        "CaptionEnglish": "T1135",
        "CaptionFrench": "T1135",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst222",
        "TaxpayerPrevYearCell": "FileStat.Towfst201",
        "BackgrounColor": "#754700",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "Non_resident",
        "CaptionEnglish": "Non-resident",
        "CaptionFrench": "Non-résident",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst223",
        "TaxpayerPrevYearCell": "FileStat.Towfst202",
        "BackgrounColor": "#FFFF00",
        "ForegroundColor": "#000000",
        "YearToCheck": 4
    },
    {
        "Id": "US_Citizen",
        "CaptionEnglish": "US Citizen",
        "CaptionFrench": "Citoyen É.-U.",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst224",
        "TaxpayerPrevYearCell": "FileStat.Towfst203",
        "BackgrounColor": "#cf7842",
        "ForegroundColor": "#ffffff",
        "YearToCheck": 4
    },
    {
        "Id": "Farming",
        "CaptionEnglish": "Farming",
        "CaptionFrench": "Agricole",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst226",
        "TaxpayerPrevYearCell": "FileStat.Towfst225",
        "BackgrounColor": "#85BC20",
        "ForegroundColor": "#000000",
        "YearToCheck": 4
    },
    {
        "Id": "Fishing",
        "CaptionEnglish": "Fishing",
        "CaptionFrench": "Pêche",
        "DescriptionEnglish": "",
        "DescriptionFrench": "",
        "TaxpayerCell": "FileStat.Towfst230",
        "TaxpayerPrevYearCell": "FileStat.Towfst231",
        "BackgrounColor": "#E6F2F9",
        "ForegroundColor": "#000000",
        "YearToCheck": 4
    }
]
